import { ProtocolVersionLatest } from '@standardnotes/common';
import { createOperatorForVersion } from './Functions';
export class EncryptionOperators {
    constructor(crypto) {
        this.crypto = crypto;
        this.operators = {};
        this.crypto = crypto;
    }
    deinit() {
        ;
        this.crypto = undefined;
        this.operators = {};
    }
    operatorForVersion(version) {
        const operatorKey = version;
        let operator = this.operators[operatorKey];
        if (!operator) {
            operator = createOperatorForVersion(version, this.crypto);
            this.operators[operatorKey] = operator;
        }
        return operator;
    }
    /**
     * Returns the operator corresponding to the latest protocol version
     */
    defaultOperator() {
        return this.operatorForVersion(ProtocolVersionLatest);
    }
}
